import {basesOperationLabel, Selector, wordings} from "../mixins/dictionaries.js";
import {paddingOligoEditor as paddingEditor} from "../mixins/constants.js";
import {
    copyToClipboard,
    countSelectedBases,
    getEncodings,
    getFriendlyIdAtPosition,
    getNextSortKey,
    getRangeBases,
    search,
    oligoEditorPath,
    oligoSlotEditorPath,
    getElementByPk,
    fixedMaxValue
} from "./utils.js";

import * as crossMapLookup from "../oligo/crossMapLookup";

import {
    fixValidEnd,
    loadModal,
    thousandSeparator,
    validInputValueEdges
} from "../editor/utils";
import {appendToast} from "../bootstrap";

export default class Toolbar {
    constructor(settings, mediator) {
        this.settings = {
            ...settings
        }
        this.mediator = mediator;
        this.initDataContainer();
        this.initSelectors(Selector.TOOLBAR);

        this.bindEvents();
    }

    setData(decodedStructuredData, sourceData) {
        this.initData(decodedStructuredData, sourceData);
        this.setSelectors();
        this.printSummary();
    }

    initData(decodedStructuredData, sourceData) {
        this.sequence = decodedStructuredData.sequence;
        this.sequenceMapped = decodedStructuredData["decodedCartoonMap"];
        this.crossMap = decodedStructuredData["decodedCrossMap"];
        this.encodingTokens = decodedStructuredData["encodingTokens"]

        this.onlyCharacters = this.crossMap.filter(item => item.symbol !== "|")
        this.characters = this.sequenceMapped.filter(item => !item.bond);

        this.sequenceLength = this.characters.length;
        this.slots = sourceData.slots;

        this.searchResultCurrentPosition = 0;
        this.searchResult = [];

        this.baseLength.forEach(label => {
            label.innerHTML = this.sequenceLength
        })

        /**
         * set currentEncodingAnchor
         * */
        if (!this.settings.hasSlots) {
            this.currentEncodingAnchor.friendlyID = sourceData.friendly_id;
        } else {
            this.currentEncodingAnchor.friendlyID = getFriendlyIdAtPosition(this.rangeBases.start, this.slots, "sequence", this.characters)
        }
        this.currentEncodingAnchor.sortKey = getNextSortKey(this.crossMap, Math.round(this.rangeBases.start), "sequence");
    }

    initDataContainer() {
        this.rangeBases = {
            start: 0,
            end: 0,
            length: 0
        }

        this.sourceObject = "sequence";
        this.slots = [];
        this.affectedEncodedTypes = [];
        this.affectedSlots = [];

        this.charIndex = 0;
        this.currentEncodingAnchor = {
            "friendlyID": null,
            "sortKey": null
        }

        this.EventsOn();
    }

    initSelectors(container) {
        this.$modalContainer = document.querySelector(Selector.MODAL);

        this.$mainPanel = document.querySelector(`${container} #mainPanel`);


        this.$tabCursor = this.$mainPanel.querySelector(`li a[href="#moveTo"]`);
        this.$tabSearch = this.$mainPanel.querySelector(`li a[href="#search"]`);
        this.$tabRange = this.$mainPanel.querySelector(`li a[href="#range"]`);

        this.$contentPanel = document.querySelector(`${container} #secondaryPanel`);

        /**
         * Go to panel
         * */
        this.$tabContainerCursor = this.$contentPanel.querySelector("#moveTo");
        this.$baseBpCursor = this.$tabContainerCursor.querySelector("#cursorPosition");
        this.$cursorButtons = this.$tabContainerCursor.querySelectorAll("#goToStart, #goToBase, #goToEnd");
        this.$insertButton = this.$tabContainerCursor.querySelector("[data-type=insert-bases]")

        /**
         * Select panel
         * */
        this.$tabContainerRange = this.$contentPanel.querySelector('#range');
        this.$baseBpFrom = this.$tabContainerRange.querySelector("#fromBp");
        this.$baseBpTo = this.$tabContainerRange.querySelector("#toBp");

        this.$rangeButtons = this.$tabContainerRange.querySelectorAll("[data-change-encoded-data]");

        /**
         * Select search
         * */
        this.$tabContainerSearch = this.$contentPanel.querySelector('#search');
        this.$searchForm = this.$contentPanel.querySelector('form');
        this.$txtToSearch = this.$tabContainerSearch.querySelector("#txtToSearch")
        this.$elementsFound = this.$tabContainerSearch.querySelector("#elementsFound")
        this.$searchButtons = this.$tabContainerSearch.querySelectorAll("a[role=button]");

        /**
         * all inputs MovePanel and RangePanel
         */
        this.$baseBpInputs = document.querySelectorAll("input#cursorPosition, input#fromBp, input#toBp");
        /**
         * Slot item buttons
         * */
        this.$slotDDMenuItemsContainer = this.$contentPanel.querySelector("#slotItemButtons");
        this.$slotDDMenuItems = this.$slotDDMenuItemsContainer.querySelectorAll(".dropdown-toggle,.dropdown-menu");
        this.$slotButtons = this.$slotDDMenuItemsContainer.querySelectorAll("[data-slot-button]");
        /**
         * sliders
         * */
        const $overviewPanel = document.querySelector('#overviewTools');

        this.$slider = $overviewPanel.querySelector("#sliderScroll");
        this.$sliderButtons = $overviewPanel.querySelectorAll("[data-editor-scroll]");


        this.baseLength = document.querySelectorAll('[data-need-bases-length]');
        this.$summary = document.querySelector('.overview');

        this.$toastContainer = document.querySelector(Selector.TOASTS);
    }

    setSelectors() {
        this.$baseBpCursor.value = Math.round(this.rangeBases.start);
        this.$baseBpFrom.value = Math.round(this.rangeBases.start);
        this.$baseBpTo.value = Math.round(this.rangeBases.end);

        this.$slider.min = 1;
        this.$slider.value = 1;

        this.$baseBpCursor.max = this.sequenceLength + 1;
        this.$baseBpFrom.max = this.sequenceLength;
        this.$baseBpTo.max = this.sequenceLength;
        this.$slider.max = this.sequenceLength;

        this.setInputValues(this.rangeBases.start + 1, this.rangeBases.start + 1)
        this.activePanel = "moveTo";
        this.setTabs();
        this.printSummary();
    }

    setTabs() {
        this.$mainPanel.querySelectorAll('li.nav-item a').forEach((el) => {
            el.classList.remove('active');
            if (el.getAttribute('href') === `#${this.activePanel}`) el.classList.add('active');
        });

        this.$contentPanel.querySelectorAll('.tab-pane').forEach((el) => {
            el.classList.remove('show');
            el.classList.remove('active');
            if (el.id === `${this.activePanel}`) {
                el.classList.add('show');
                el.classList.add('active');
            }
        });
    }

    printSummary() {
        let listBody = `
            <div>
                Total nt.: <strong class="needs-bp-length">${thousandSeparator(this.sequenceLength)}</strong>
            </div>
        `;

        if (this.activePanel === "range") {
            const fromBp = parseInt(this.$baseBpFrom.value);
            const toBp = parseInt(this.$baseBpTo.value);
            let realToBp = fixValidEnd(fromBp, toBp, this.sequenceLength)

            listBody += `<div>
                Selected: <strong class="rangeLength">${thousandSeparator(realToBp - fromBp + 1)}</strong> nt.
            </div> 
            <div>
                From <strong class="rangeFrom">${thousandSeparator(fromBp)}</strong> to <strong class="rangeTo">${thousandSeparator(toBp)}</strong> 
            </div>`;
        } else {
            listBody += `
                <div>
                    Cursor before nt.: <strong class="cursorPosition">${thousandSeparator(this.$baseBpCursor.value)}</strong>
                </li>
            `;
        }
        this.$summary.innerHTML = `<div class="d-flex gap-3 text-body-tertiary">${listBody}</div>`;
    }

    bindEvents() {
        this.$tabCursor.addEventListener("click", (e) => {
            e.preventDefault();

            const inputValue = +this.$baseBpFrom.value;
            this.rangeBases = {
                start: inputValue - 1,
                end: inputValue - 1,
                length: 0
            }

            this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end + 1)

            this.setCurrentEncodingAnchor({
                "currentPosition": this.rangeBases.start,
                "source": "sequence"
            });

            this.activePanel = "moveTo";
            this.setTabs();
            this.dispatchRangeSelection();

            this.resetSearch();
        });

        this.$tabRange.addEventListener("click", (e) => {
            e.preventDefault();

            const inputValue = +this.$baseBpCursor.value;

            this.rangeBases = {
                start: inputValue - 1,
                end: inputValue,
                length: 1
            }

            this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end);
            this.affectedEncodedTypes = getEncodings(this.crossMap, this.rangeBases.start, this.rangeBases.end, "sequence");

            this.activePanel = "range";
            this.setTabs();
            this.dispatchRangeSelection();

            this.resetSearch();
        });

        this.$baseBpInputs.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.changeBasePairInput(e)
            })
            el.addEventListener("keyup", (e) => {
                this.changeBasePairInput(e)
            })
            el.addEventListener("keydown", (e) => {
                if (e.code === "Enter") {
                    this.changeBasePairInput(e)
                }
            })
        });

        this.$cursorButtons.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                let inputValue = +this.$baseBpCursor.value;
                if (el.id === "goToStart" || el.id === "goToEnd") {
                    inputValue = el.id === "goToStart" ? 1 : this.sequenceLength + 1;
                }

                this.rangeBases = {
                    start: inputValue - 1,
                    end: inputValue - 1,
                    length: 0
                }

                this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end + 1)

                this.setCurrentEncodingAnchor({
                    "currentPosition": this.rangeBases.start,
                    "source": "sequence"
                })

                this.$slider.value = this.rangeBases.start;
                this.dispatchRangeSelection();
            })
        });

        this.$insertButton.addEventListener("click", e => {
            const button = e.currentTarget;
            e.preventDefault();

            let sortKey = this.currentEncodingAnchor.sortKey;

            const currentSlot = this.settings.hasSlots
                ? this.slots.find(s => s.dna_sequence.friendly_id === this.currentEncodingAnchor.friendlyID)
                : null;

            const modalUrl = oligoEditorPath("create", this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, null)
            const params = `sort_key=${sortKey}`
            loadModal(modalUrl, params, wordings.coming_soon);
        })

        this.$rangeButtons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                if (button.dataset.changeEncodedData === "select-all") {
                    this.rangeBases = {
                        start: 0,
                        end: this.sequenceLength,
                        length: this.sequenceLength
                    }

                    this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end)
                    this.$slider.value = this.rangeBases.start + 1;
                    this.dispatchRangeSelection();
                }

                if (button.dataset.changeEncodedData === "copy") {
                    const fromInputValue = parseInt(this.$baseBpFrom.value);
                    let toInputValue = parseInt(this.$baseBpTo.value)

                    this.rangeBases = {
                        start: fromInputValue - 1,
                        end: toInputValue,
                        length: (this.rangeBases.end - this.rangeBases.start)
                    }
                    const temp_start = this.crossMap.find(item => item.sequence.start === this.rangeBases.start && !item.bond).raw.start;
                    const temp_end = this.crossMap.find(item => item.sequence.end === this.rangeBases.end).raw.end;
                    const basePairsSelected = getRangeBases(temp_start, temp_end, this.sequence);
                    copyToClipboard(basePairsSelected, Selector.TOASTS);
                }

                if (button.dataset.changeEncodedData === "delete") {
                    if (this.affectedSlots.length > 1) {
                        appendToast(document.querySelector(Selector.TOASTS), wordings["multiple_slots"]);
                    } else {
                        const params = this.affectedEncodedTypes.map(n => `pk=${n}`).join('&');
                        const currentSlot = this.settings.hasSlots
                            ? this.slots.find(s => s.dna_sequence.friendly_id === this.currentEncodingAnchor.friendlyID)
                            : null;

                        let modalUrl = oligoEditorPath("delete", this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, null)
                        loadModal(modalUrl, params, wordings.coming_soon);
                    }
                }
            })
        });

        this.$slotButtons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                let modalUrl = "";
                const currentSlot = this.settings.hasSlots
                    ? this.slots.find(s => s.dna_sequence.friendly_id === this.currentEncodingAnchor.friendlyID)
                    : null;

                if (button.dataset.slotButton === "duplicate-and-replace") {
                    modalUrl = oligoSlotEditorPath(currentSlot?.urls?.view, "duplicate-and-replace")
                    if (!modalUrl) return;
                    loadModal(modalUrl, "", wordings.coming_soon);
                }
            })
        });

        this.$searchForm.addEventListener("submit", (e) => {
            e.preventDefault();
            this.searchResult = search(this.$txtToSearch.value, this.encodingTokens, this.sequenceMapped)

            if (this.searchResult.length) {
                this.searchResultCurrentPosition = 0;
                this.moveOnSearch(this.searchResultCurrentPosition);
            } else {
                appendToast(document.querySelector(Selector.TOASTS), wordings["no_results_found"]);
                this.resetSearch()
            }
        });

        this.$searchButtons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                if (button.id === "goSearch") {
                    this.searchResult = search(this.$txtToSearch.value, this.encodingTokens, this.sequenceMapped)

                    if (this.searchResult.length) {
                        this.searchResultCurrentPosition = 0;
                        this.moveOnSearch(this.searchResultCurrentPosition);
                    } else {
                        appendToast(document.querySelector(Selector.TOASTS), wordings["no_results_found"]);
                        this.resetSearch()
                    }
                } else if (this.searchResult.length && (button.id === "left" || button.id === "right")) {
                    const step = button.id === "right" ? 1 : -1;
                    const next = this.searchResultCurrentPosition + step;

                    if (next >= 0 && next < this.searchResult.length) {
                        this.searchResultCurrentPosition = next;
                        this.moveOnSearch(this.searchResultCurrentPosition);
                    }
                } else if (button.id === "reset") {
                    this.resetSearch()
                }
            })
        });


        this.$slider.addEventListener("change", e => {
            const inputValue = +e.target.value;

            this.rangeBases = {
                start: inputValue - 1,
                end: (inputValue + this.rangeBases.length) - 1,
                length: this.rangeBases.length
            }

            let endInputValue = this.rangeBases.end;
            if (this.rangeBases.end + this.rangeBases.length > this.sequenceLength) {
                endInputValue = this.rangeBases.end - 1
            }

            this.setCurrentEncodingAnchor({
                "currentPosition": this.rangeBases.start,
                "source": "sequence"
            });

            this.setInputValues(this.rangeBases.start + 1, endInputValue)
            this.dispatchRangeSelection();
        })

        this.$sliderButtons.forEach(el => {
            el.addEventListener("click", () => {
                let step = +(el.dataset.editorScroll);

                if ((this.rangeBases.start + step) < 0 || (this.rangeBases.end + step) >= this.sequenceLength) {
                    step = 0;
                }

                this.rangeBases = {
                    start: this.rangeBases.start + step,
                    end: this.rangeBases.end + step,
                    length: this.rangeBases.length
                }

                this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end)

                this.setCurrentEncodingAnchor({
                    "currentPosition": this.rangeBases.start,
                    "source": "sequence"
                });

                this.$slider.value = this.rangeBases.start;
                this.dispatchRangeSelection();
            })
        })
    }

    changeBasePairInput(event) {
        event.preventDefault();
        event.stopPropagation();
        const $input = event.currentTarget;

        if ((event.type === "click" || event.code === "Enter") &&
            this.currentValueInputs[$input.id] !== parseInt($input.value)
        ) {

            const inputValue = +$input.value;
            const inputName = $input.id;

            if (this.checkBaseNumber(inputName)) {
                if (inputName === "cursorPosition") {
                    this.activePanel = "moveTo";

                    this.rangeBases = {
                        start: inputValue - 1,
                        end: inputValue - 1,
                        length: 0
                    }

                    this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end + 1)

                    this.setCurrentEncodingAnchor({
                        "currentPosition": this.rangeBases.start,
                        "source": "sequence"
                    });

                    this.$slider.value = this.rangeBases.start;
                    this.dispatchRangeSelection();
                } else {
                    this.activePanel = "range";
                    const fromInputValue = fixedMaxValue(this.$baseBpFrom.value, 1, this.sequenceLength);
                    let toInputValue = fixedMaxValue(this.$baseBpTo.value, 1, this.sequenceLength);

                    if (fromInputValue > toInputValue) {
                        this.rangeBases = {
                            start: fromInputValue - 1,
                            end: fromInputValue - 1,
                            length: 0
                        }

                        this.activePanel = "moveTo";

                        this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end + 1)

                        this.setCurrentEncodingAnchor({
                            "currentPosition": this.rangeBases.start,
                            "source": "sequence"
                        });

                        this.setTabs();
                        this.dispatchRangeSelection();
                    } else {
                        this.rangeBases = {
                            start: fromInputValue - 1,
                            end: toInputValue,
                            length: (this.rangeBases.end - this.rangeBases.start)
                        }

                        this.affectedEncodedTypes = getEncodings(this.crossMap, this.rangeBases.start, this.rangeBases.end, "sequence");

                        this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end)

                        this.$slider.value = this.rangeBases.start + 1;

                        this.toggleSlotItemsContainer();
                        this.dispatchRangeSelection();
                    }
                }
            }
        }
    }

    dispatchRangeSelection() {
        this.printSummary();

        this.EventsTrigger("setOffsetScroll", {
            "end": this.rangeBases.end + 1,
            "source": this.sourceObject
        });

        this.EventsTrigger("slide", "end");
        this.EventsTrigger("updateRender");

        this.EventsTrigger("selectRange", {
            start: this.rangeBases.start + 1,
            end: this.rangeBases.end + 1,
            source: this.sourceObject
        });

    }

    initSearch() {
        this.searchResult = []
        this.$txtToSearch.value = "";
        this.$elementsFound.innerHTML = `0 of 0`;
    }

    resetSearch() {
        this.initSearch();
    }

    moveOnSearch(position) {
        this.$elementsFound.innerHTML = `${position + 1} of ${this.searchResult.length}`;

        const start = this.onlyCharacters.find(item => item.cartoon.start === this.searchResult[position].cartoonStart).sequence.start
        const end = this.onlyCharacters.find(item => item.cartoon.end === this.searchResult[position].cartoonEnd).sequence.end

        this.rangeBases = {
            start,
            end,
            length: end - start
        }

        this.setInputValues(this.rangeBases.start + 1, this.rangeBases.end + 1)
        this.$slider.value = this.rangeBases.start;

        this.printSummary();

        this.EventsTrigger("setOffsetScroll", {
            "end": this.rangeBases.end + 1,
            "source": this.sourceObject
        })

        this.EventsTrigger("selectRange", {
            start: this.searchResult[position].cartoonStart + 1,
            end: this.searchResult[position].cartoonEnd + 1,
            source: "cartoon"
        });

        this.EventsTrigger("slide", "end")
        this.EventsTrigger("updateRender")

    }

    selectRange(data) {
        const selectedBases = countSelectedBases(data.start, data.end, this.crossMap, data.source, paddingEditor);

        this.affectedEncodedTypes = [...selectedBases.characters, ...selectedBases.bonds];

        this.affectedSlots = this.slots
            .filter(slot => slot.dna_sequence.encodings.some(item => this.affectedEncodedTypes.includes(item.id)))
            .map(slot => slot.dna_sequence.friendly_id);

        this.charIndex = selectedBases.charIndex;

        let startSequence = selectedBases.sequence.start
        let endSequence = selectedBases.sequence.end

        this.rangeBases = {
            start: startSequence,
            end: endSequence,
            length: selectedBases.characters.length
        }

        if (startSequence === endSequence) {
            this.activePanel = "moveTo";
        } else {
            this.activePanel = "range";
            if (this.settings.hasSlots) {
                this.toggleSlotItemsContainer();
            }
        }

        let startInputValue = this.rangeBases.start + 1;
        let endInputValue = this.rangeBases.end + 1;
        if (this.rangeBases.length > 0) {
            endInputValue = this.rangeBases.end
        }

        this.setInputValues(startInputValue, endInputValue)
        this.setTabs();
        this.printSummary();

        this.$slider.value = selectedBases.sequence.start;
    }

    setInputValues(fomBase, toBase) {
        this.$baseBpCursor.value = fomBase;
        this.$baseBpFrom.value = fomBase;
        this.$baseBpTo.value = toBase;

        if (fomBase === this.sequenceLength + 1) {
            this.$baseBpFrom.value = fomBase - 1;
        }

        if (toBase === 0) {
            this.$baseBpTo.value = 1;
        }

        this.currentValueInputs = {
            'fromBase': this.$baseBpFrom.value,
            'toBase': this.$baseBpTo.value,
            'cursorPosition': this.$baseBpCursor.value
        };
    }

    checkBaseNumber(operation) {
        const operationTypes = [basesOperationLabel.insert, basesOperationLabel.upload, basesOperationLabel.inject, "cursorPosition"];
        const positionField = ["cursorPosition", "fromBp", "toBp"];
        let warningMessage = "";

        positionField.forEach((field) => {
            const inputElement = document.querySelector('#' + field);
            const currentValue = parseInt(inputElement.value);

            const minAllowed = parseInt(inputElement.min);
            const maxAllowed = parseInt(inputElement.max)

            if (!validInputValueEdges(currentValue, minAllowed, maxAllowed, operationTypes.includes(operation))) {
                warningMessage = "review_input";
            }
        });

        if (warningMessage !== "") {
            appendToast(this.$toastContainer, wordings[warningMessage], 1)
            return false;
        }

        return warningMessage === "";
    }

    contextMenuEditorEvents(data) {
        const $contextMenuInsertItem = document.querySelectorAll(`${Selector.POPPER_MENU} [data-action-group=new]:not(.d-none) [data-change-encoded-data]`) || [];
        const $contextMenuDeleteItem = document.querySelectorAll(`${Selector.POPPER_MENU} [data-action-group=delete]:not(.d-none) [data-change-encoded-data]`) || [];
        const $contextMenuModifiedItems = document.querySelectorAll(`${Selector.POPPER_MENU} [data-action-group=modified]:not(.d-none) [data-change-encoded-data]`) || [];
        let modalUrl = "";

        if (data.start !== data.end) {
            this.affectedEncodedTypes = getEncodings(this.crossMap, data.start - 1, data.end - 1, data.source);
        }

        const currentSlot = this.settings.hasSlots
            ? this.slots.find(s => s.dna_sequence.friendly_id === this.currentEncodingAnchor.friendlyID)
            : null;

        // create
        $contextMenuInsertItem.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();

                let sortKey = this.currentEncodingAnchor.sortKey;

                modalUrl = oligoEditorPath("create", this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, null)
                const params = `sort_key=${sortKey}`
                loadModal(modalUrl, params, wordings.coming_soon);
            })
        })

        // delete multiple encodings
        $contextMenuDeleteItem.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                if (this.affectedSlots.length > 1) {
                    appendToast(document.querySelector(Selector.TOASTS), wordings["multiple_slots"]);
                } else {
                    const params = this.affectedEncodedTypes.map(n => `pk=${n}`).join('&');
                    modalUrl = oligoEditorPath("delete", this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, null);
                    loadModal(modalUrl, params, wordings.coming_soon);
                }
            })
        })

        // update/delete/view single encoding
        $contextMenuModifiedItems.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                if (item.dataset.changeEncodedData === "delete") {
                    const params = this.affectedEncodedTypes.map(n => `pk=${n}`).join('&');
                    modalUrl = oligoEditorPath("delete", this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, null)
                    loadModal(modalUrl, params, wordings.coming_soon);
                } else {
                    const action = item.dataset.changeEncodedData === "update" ? "update" : "";
                    const currentEncoding = getElementByPk(this.sequenceMapped, this.affectedEncodedTypes[0])

                    if (currentEncoding.enc.editable) {
                        modalUrl = oligoEditorPath(action, this.settings.hasSlots, currentSlot?.pk, this.currentEncodingAnchor.friendlyID, currentEncoding.enc.id)
                        loadModal(modalUrl, "", wordings.coming_soon);
                    } else {
                        appendToast(document.querySelector(Selector.TOASTS), wordings["operation_is_not_allowed"]);
                    }
                }
            })
        })
    }

    contextMenuSlotEvents(slot) {
        const $contextMenuSlotItems = document.querySelectorAll(`${Selector.POPPER_MENU} [data-slot-button]`) || [];
        let modalUrl = "";

        const currentSlot = this.settings.hasSlots
            ? this.slots.find(s => s.dna_sequence.friendly_id === this.currentEncodingAnchor.friendlyID)
            : null;

        $contextMenuSlotItems.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                if (item.dataset.slotButton === 'duplicate-and-replace') {
                    modalUrl = oligoSlotEditorPath(currentSlot?.urls?.view, "duplicate-and-replace")
                    if (!modalUrl) return;
                    loadModal(modalUrl, "", wordings.coming_soon);
                }
            })
        })
    }

    setCurrentEncodingAnchor(data) {
        if (this.slots.length) {
            this.currentEncodingAnchor.friendlyID = getFriendlyIdAtPosition(data.currentPosition, this.slots, data.source, this.characters);
        }
        this.currentEncodingAnchor.sortKey = getNextSortKey(this.crossMap, Math.round(data.currentPosition), data.source);
    }

    toggleSlotItemsContainer() {
        this.$slotDDMenuItemsContainer?.classList.add("disabled");
        this.$slotDDMenuItems?.forEach(el => el.classList.remove("show"));

        const isSlotRangeMatch = this.slots.some(slot => {
            const range = crossMapLookup.lookupRange(
                this.onlyCharacters,
                { start: slot.start, end: slot.end },
                { from: "cartoon", to: "sequence" }
            );

            return range?.start === this.rangeBases.start && range?.end === this.rangeBases.end;
        });

        if (isSlotRangeMatch) {
            this.currentEncodingAnchor.friendlyID = this.affectedSlots[0];
        }

        this.$slotDDMenuItemsContainer?.classList.toggle("disabled", !isSlotRangeMatch);
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("selectRange", "selectRange", this);
            this.mediator.on("appendContextMenuEditorEvents", "contextMenuEditorEvents", this)
            this.mediator.on("appendContextMenuSlotEvents", "contextMenuSlotEvents", this)
            this.mediator.on("setCurrentEncodingAnchor", "setCurrentEncodingAnchor", this);
        }
    }
}